import { useId, type SVGProps } from "react";

type NavIconProps = SVGProps<SVGSVGElement> & {
  size?: number;
  colors?: [string, string];
};

/**
 * Stroke versions of lola `BackArrow` / `Close`, sharing one stroke weight so
 * the navbar back, sheet back and sheet close read the same at 36px.
 */
export const BackArrowLight: React.FC<NavIconProps> = ({
  size = 36,
  colors = ["#000", "#000"],
  strokeWidth = 1.5,
  ...props
}) => {
  const gradientId = `back-arrow-light-${useId()}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="24" y2="0" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor={colors[0]} />
          <stop offset="100%" stopColor={colors[1]} />
        </linearGradient>
      </defs>
      <path
        d="M19.25 12H4.75M10 6.75 4.75 12 10 17.25"
        stroke={`url(#${gradientId})`}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CloseLight: React.FC<NavIconProps> = ({
  size = 36,
  colors = ["#000", "#000"],
  strokeWidth = 1.5,
  ...props
}) => {
  const gradientId = `close-light-${useId()}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="24" y2="0" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor={colors[0]} />
          <stop offset="100%" stopColor={colors[1]} />
        </linearGradient>
      </defs>
      <path
        d="M6.5 6.5l11 11M17.5 6.5l-11 11"
        stroke={`url(#${gradientId})`}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};
